import Map from '../classes/Map';
import Registry from '../plugins/Registry';
import Cookie from "../plugins/Cookie";

const map = map => new Map(map);
const maps = $('[map]');


$(document).ready(function () {
  const maps = $('[map]');
  if (maps.length && (typeof ymaps !== 'undefined')) {
    ymaps.ready(function () {
      maps.each(function () {
        map($(this));
      });
    });
  }
})

$(function () {
  $('#link_map').on('click', function (e) {
    $('html,body').stop().animate({ scrollTop: $('#map').offset().top }, 1000);
    e.preventDefault();
  });
});

$(function () {
  let filterTimeout;
  let cityList;
  let ajax;
  let ids = [];
  let _ids = [];
  let city;
  let updateTerminal;

  const emptyResultMessage = $('#empty-result');
  const defaultMessage = 'По запросу ничего не найдено';
  const searchingMessage = 'В данном регионе ведется активный поиск дилера (<a class="link link_bold link_bordered" href="/about/became-dealer/">Как стать дилером</a>)';
  const input = $('.map-block__search input');
  const select = $('#map-block_form select');
  const map = $('[map]');

  let mapObject = {};

  const emptyResultMessageShow = data => {
    if (data && data.isSearchingMessage && !window.dealer)
      emptyResultMessage.find('.dealer__name').html(searchingMessage);
    else
      emptyResultMessage.find('.dealer__name').html(defaultMessage);

    emptyResultMessage.show();
  };

  const emptyResultMessageHide = () => emptyResultMessage.hide();
  // const nearestShow = () => nearest.show();
  // const nearestHide = () => nearest.hide();

  if (map.length) {
    $.ajax({
      url: '/ajax/city/list/',
      type: 'JSON',
      method: 'POST',
      success: data => {

        cityList = data.list;
        input.parent().removeClass('disabled');

      }
    });

    if (Cookie.get('city')) {
      mapObject = Registry.get('yamap', map.attr('id'));
      updateTerminal = setInterval(() => {
        if (mapObject) {
          clearInterval(updateTerminal);
          selectChange();
        } else {
          mapObject = Registry.get('yamap', map.attr('id'));
        }

      }, 100);
    } else {
      $.ajax({
        url: '/ajax/city/salons/',
        type: 'JSON',
        method: 'POST',
        beforeSend: () => {
          input.parent().addClass('disabled');
        },
        complete: () => {
          input.parent().removeClass('disabled');
        },
        success: (data) => {
          if (data.ids.length) {
            ids = data.ids;
            _ids = [...ids];

          }
        },
        error: (data) => {
          console.log(data);
        }
      });
    }
  }

  const dealerList = $('.map-block__list .dealer');

  function selectChange() {
    city = select.val();
    if (ajax && (typeof ajax.abort === 'function')) {
      ajax.abort();
    }

    // if (city) {
    //     nearestShow();
    // } else {
    //     nearestHide();
    // }

    ajax = $.ajax({
      url: '/ajax/city/salons/',
      type: 'JSON',
      method: 'POST',
      data: {
        city: city
      },
      beforeSend: () => {
        input.parent().addClass('disabled');
      },
      complete: () => {
        input.parent().removeClass('disabled');
      },
      success: (data) => {
        if (data.ids.length) {
          ids = data.ids;
          _ids = [...ids];
        }

        filterByIds();
        successFunction(data, city);
      },
      error: (data) => {
        console.log(data);
      }
    });
  }

  function filterByIds() {
    dealerList.each(function () {
      if (ids.indexOf(parseInt($(this).data('id'))) === -1)
        $(this).hide();
      else
        $(this).show();
    });
  }

  function inputChange(value) {
    _ids = [...ids];
    dealerList.each(function () {
      const id = $(this).data('id');
      const match = $(this).data('search').toLowerCase().indexOf(value.toLowerCase()) !== -1;
      if (_ids.indexOf(id) !== -1) {
        if (value === '' || match) {
          $(this).show();
        } else {
          _ids.remove(_ids.indexOf(id));
          $(this).hide();
        }
      }
    });

    successFunction(false, value);
  }

  function successFunction(data, value) {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      mapObject.filterByIDs(_ids.length ? _ids : ids);
      if (value !== '') log(value);
    }, 550);

    if (_ids.length === 0) {
      emptyResultMessageShow(data);
    } else {
      emptyResultMessageHide();
    }
  }

  select.on('change', function () {
    mapObject = Registry.get('yamap', map.attr('id'));
    selectChange();
    filterByIds();
  });

  input.on('input', function (e) {
    e.preventDefault();
    mapObject = Registry.get('yamap', map.attr('id'));

    // const value = preg_quote($(this).val());
    const value = $(this).val();
    inputChange(value);

    if (!city) checkCity(value);

  });

  function checkCity(value) {
    return value;
  }

  const log = value => {
    $.ajax({
      url: '/ajax/search/log/',
      type: 'JSON',
      method: 'POST',
      data: {
        search: value
      },
    });
  };

  $('.dealer').click(function (e) {
    if (e.target.tagName === 'A') return;
    const id = $(this).parents('.map-block__right').prev().find('[map]').eq(0).attr('id');
    if (typeof id === 'undefined')
      return;

    const map = Registry.get('yamap', id);

    if (typeof map === 'undefined')
      return;

    const dealer = map.findInData('id', $(this).data('id'));

    if (!dealer)
      return;

    if ($(this).hasClass('active') && !$(e.target).hasClass('btn__map')) {
      $(this).removeClass('active');
      map.calcCenter();
      return;
    }

    $(this).siblings().removeClass('active');
    $(this).addClass('active');


    map.map.setCenter([dealer.lat, dealer.lng], 12, { duration: 500 });
  });
});
